/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  
  {
    url: "/candidat/dashboard/ecommerce",
    name: "ecommerce",
    
    icon: "HomeIcon",
    i18n: "accueil",
    slug: "dashboard-ecommerce",
    
  },
  
  {
    header: "application",
    icon: "PackageIcon",
    i18n: "Liste",
    items: [
      /*{
        url: null,
        name: "User",
        icon: "UserIcon",
        i18n: "candidat",
        submenu: [
          {
            url: '/formateur/application/candidat/user-list',
            name: "List",
            slug: "app-user-list",
            i18n: "List",
          },
          
        ]
      },*/
      
      {
        url: '/candidat/application/domaine/user-list',
        name: "User",
        icon: "ListIcon",
        i18n: "domaine",
        slug: "app-user-list",
        
      },
      {
        name: "User",
        icon: "ListIcon",
        i18n: "formation",
        url: '/candidat/application/formation/user-list',
        slug: "app-user-list",
        
      },
      {
        url: '/candidat/application/classe/user-list',
        name: "classe",
        icon: "ListIcon",
        i18n: "groupe",
        slug: "app-classe-list",
        
      },


    ]},    
  //payement
  /*{
    header: "payement",
    icon: "PackageIcon",
    i18n: "payement",
    items: [
      {
        url: null,
        name: "liste",
        icon: "UserIcon",
        i18n: "payement",
        submenu: [
          {
            url: '/formateur/payement/candidat/list/:filter/:groupe',
            name: "candidat",
            slug: "payement-candidat-list",
            i18n: "list",
          },
          
          
        ]
      },
    ]}, */    
  //apps 
  {
    header: "Calendar",
    icon: "PackageIcon",
    i18n: "Application",
    items: [
      {
        url: "/candidat/calendar",
        name: "Calendar",
        slug: "calendar-simple-calendar",
        icon: "CalendarIcon",
        tagColor: "success",
        i18n: "Calendar",
      },
      
      
  
        ]
     
      
  },
  {
    header: "Paramétré",
    icon: "PackageIcon",
    i18n: "Paramétré",
    items: [
      {
        url: '/candidat/compte-settings',
        slug: 'page-compte-settings',
        name: "Compte Settings",
        icon: "SettingsIcon",
        i18n: "Paramétre compte",
      },
  
        ]
     
      
  },
  
]

